import getKey from './getKey';
import parseS3Uri from './parseS3Uri';

function parseImageUri(uri: string): { bucket: string; key: string } {
  if (uri.startsWith('s3://')) return parseS3Uri(uri);

  const bucket = uri.split('/')[2]?.split('.')[0] || 'empty_bucket';
  const key = getKey(uri) || 'empty_key';
  return { bucket, key };
}

export default parseImageUri;
